import { RAMSALAB_ORG } from "../constants/constants";

export default function globalParams() {
  const org = localStorage.getItem(RAMSALAB_ORG) || "";

  return { org: org };
}
